import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'usNumberFormat'
})
export class UsNumberFormatPipe implements PipeTransform {

  transform(value: string): string {
    // Assuming value is a 10-digit number (e.g., '5243543565')
    const cleanedNumber = value.replace(/\D/g, ''); // Remove non-digit characters
    console.log("cleanedNumber",cleanedNumber)
    return `(${cleanedNumber.slice(0, 3)}) ${cleanedNumber.slice(3, 6)}-${cleanedNumber.slice(6)}`;
}

}
